import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    stock: null,
    stock_loading: false,
    stock_loading_errors: null,
    stock_saving: false,
    stock_saving_errors: null,
};

const mutations = {

    updateStock(state, stock) {
        state.stock = stock;
    },
    updateStockLoading(state, loading) {
        state.stock_loading = loading;
    },
    updateStockLoadingErrors(state, errors) {
        state.stock_loading_errors = errors;
    },
    updateStockSaving(state, saving) {
        state.stock_saving = saving;
    },
    updateStockSavingErrors(state, errors) {
        state.stock_saving_errors = errors;
    },
    updateStockDeleting(state, deleting) {
        state.stock_deleting = deleting;
    },
};

const actions = {

    async fetchStock({ commit, dispatch, state }, params) {
        commit('updateStockLoading', true);
        commit('updateStockLoadingErrors', null);
        let url;
        if (params && params.stock_id) {
            url = `/api/stocks/${params.stock_id}/`;
        } else if (state.stock) {
            url = `/api/stocks/${state.stock.id}/`;
        } else {
            throw 'No stock to fetch';
        }
        try {
            const response = await axios.get(url);
            commit('updateStock', response.data);
            dispatch('fetchStats');
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateStockLoadingErrors', error);
            throw error;
        } finally {
            commit('updateStockLoading', false);
        }
    },

    async deleteStock({ commit, dispatch, state }, params) {
        commit('updateStockDeleting', true);

        const url = `/api/stocks/${params.instance.id}/`;
        try {
            const response = await axios.delete(url);
            commit('updateStockDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateStockDeleting', false);
            throw error;
        } finally {
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async saveStock({ commit, dispatch, state }, params) {
        commit('updateStockSaving', true);
        commit('updateStockSavingErrors', {});

        let url = '/api/stocks/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/stocks/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            commit('updateStockSavingErrors', {});
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateStockSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateStockSaving', false);
            dispatch('session/fetchStats', null, { root: true });
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
